<div class="criteria-slab">
    <div class="criteria-slab-txt">
        {{ slabContent?.title }}
        <span class="criteria-slab-sub">{{ slabContent?.description }}</span>
    </div>
    @if (!slabContent?.isDefaultSlab) {
        <i
            class="ui-icon popper-icon"
            [closeOnInteraction]="true"
            [closeOutsideViewport]="true"
            [closeOnScroll]="true"
            (tooltipToggleChange)="changePopper($event)"
            [tooltipCustomClass]="'cdk-overlay-ph-pa'"
            [ngClass]="[isDisabled ? 'cursor-default' : '', isPopperOpen ? (isDisabled ? 'theme-info' : 'theme-info-i') : 'theme-info']"
            [dsTooltipTriggerFor]="popperContent"
            arrowPosition="middle"
            position="bottom"></i>
    }
    <ng-template #popperContent>
        @if (!isDisabled) {
            <ds-tooltip-content variant="{{ dsComponents?.dsTooltip?.variant }}" inverse="{{ dsComponents?.dsTooltip?.inverse }}">
                <button
                    slot="close"
                    ds-button-icon
                    size="small"
                    variant="flat"
                    kind="{{ dsComponents?.dsTooltip?.iconButtonKind }}"
                    inverse="{{ dsComponents?.dsTooltip?.iconButtonInverse }}">
                    <vn-icon slot="close" size="10" name="theme-ex"></vn-icon>
                </button>
                <div slot="description" [innerHtml]="rewardContent?.description"></div>
            </ds-tooltip-content>
        }
    </ng-template>
    <img class="criteria-slab-img" [attr.src]="slabImage?.src" />
</div>
